export class DateTimePeriod {
  start: Date;
  end: Date;

  constructor(start: Date | null, end: Date | null) {
    if (start) {
      this.start = start;
    }

    if (end) {
      this.end = end;
    }
  }
}
